import React from "react";
import Four from "../Pics/25.JPG";
import Five from "../Pics/5.jpg";
import Six from "../Pics/6.jpeg";
import Seven from "../Pics/7.jpg";
import Eight from "../Pics/8.jpg";
import Nine from "../Pics/21.JPG";
import Ten from "../Pics/22.JPG";
import Eleven from "../Pics/23.JPG";
import Thirteen from "../Pics/27.JPG";
import Fourteen from "../Pics/26.JPG"; 
import Fifteen from "../Pics/30.png";

import { Row, Container, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};

function Gallery() {
  return (
    <div className="">
      <div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Gallery</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <div id="portfolio" className="offset">
        <div className=" container ">
          <br />
          <br />

          <Container>
            <Row>
              <div className="col-sm-6">
                <div className="portfolio">
                  <img
                    src="https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png"
                    alt=""
                  />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi in his office.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Thirteen} alt="" />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi on his Academic dress.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Five} alt="" />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi in Israel in 2012.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Six} alt="" />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi and a colleague in Israel in
                  2012.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Seven} alt="" />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi in Pittsburg State University in
                  the US in 2013.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Eight} alt="" />
                </div>
                <p className="text-center">
                  Professor Isaac Rotimi Ajayi having an interview.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Nine} alt="" />
                </div>
                <p className="text-center">
                  Prof. Ajayi and wife, obtaining the fellowship award of the
                  Nigerian Institute of Physics (NIP).
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Ten} alt="" />
                </div>
                <p className="text-center">
                  Prof. Ajayi with some alumni of Crawford University.
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Fourteen} alt="" />
                </div>
                <p className="text-center">
                  Prof. Ajayi at a University function
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Eleven} alt="" />
                </div>
                <p className="text-center">
                  Prof. Ajayi with the Apostolic Faith District Superintendent,
                  West and Central Africa, Rev. E. A. Adeniran{" "}
                </p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Fifteen} alt="" />
                </div>
                <p className="text-center">Prof. Ajayi with grandchild</p>
              </div>

              <div className="col-sm-6">
                <div className="portfolio">
                  <img src={Four} alt="" />
                </div>
                <p className="text-center">Prof. Ajayi with a delegate</p>
              </div>
            </Row>
          </Container>
          <br />

          <div className="narrow text-center">
            <div className="col-12">
              <p className="lead">Professor Isaac Rotimi Ajayi Gallery.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
